import { Component } from '@mycolorway/tao';
import Dialog from 'next/javascripts/components/dialog';
import 'next/stylesheets/components/destroy-custom-field-dialog.scss';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-destroy-custom-field-dialog', {
  extends: [Dialog],
  mixins: [eventListenerMixin],

  ready() {
    this.listenTo(this.querySelector('.cancel'), 'click', () => this.close());
  },

  disconnected() {
    this.stopListening();
  },
});
